export default "__VITE_ASSET__Bc2KDcWL__"